import * as React from "react";
import Box from "@mui/material/Box";
import {PageTitle} from "../../components/TitleBar/PageTitle";
import Grid from "@mui/material/Grid";
import ChangePasswordForm from "../../components/ChangePasswordForm/ChangePasswordForm";
import UserInfoForm from "../../components/UserInfoForm/UserInfoForm";
import {useCurrentUser} from "../../hooks/users";


export default () => {
    const {data: user} = useCurrentUser();
    return (
        <Box>
            <PageTitle pageTitle="Account Settings"/>
            <Grid container columnSpacing={2}>
                <Grid item xs={12} md={6} sx={{mb: 2}}>
                   <UserInfoForm title="Personal Information" user={user}/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChangePasswordForm />
                </Grid>
            </Grid>
            <Grid container columnSpacing={2}>
                <Grid item xs={12} md={8}>
                    {/*<ChangeThemeContainer/>*/}
                </Grid>
            </Grid>
        </Box>
    )
}